export default {
    computed:{
        getCarPerRow() {
            const ww = window.innerWidth;
            if (ww < 480) {
                return 2;
            }
            if (ww > 480 && ww < 1220) {
                return 3
            }
            if (ww > 1220 && ww < 1440) {
                return 4;
            }
            return 5;
        },
    }
}